export default "./images/WD55.jpg";